import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { MapSettingsResponse } from "@/shared/v2/queries/interfacesV2";
import { useQuery } from "@tanstack/react-query";

const useMapOverviewSettingsQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<MapSettingsResponse>({
    queryKey: ["mapoverviewsettings", branchId],
    queryFn: () =>
      get2(`/internal/secure/pos/v2/map/overview/screen/settings/${branchId}`),
    enabled: branchId !== -1,
    initialData: {
      selected_order_statuses: [1, 2, 3, 4, 5],
      is_auto_zoom_active: true,
      zoom_level: null,
    },
    select: (data) => ({
      selected_order_statuses: data?.selected_order_statuses || [1, 2, 3, 4, 5],
      is_auto_zoom_active: data?.is_auto_zoom_active,
      zoom_level: !data?.is_auto_zoom_active
        ? (data?.zoom_level ?? null)
        : null,
    }),
  });
  return query;
};

export default useMapOverviewSettingsQuery;
